{
  "showMore": { "whenCollapsed": "Exibir mais", "whenExpanded": "Exibir menos" }
}
